
import { Component, Vue } from "vue-property-decorator";
import { Form, Message } from "element-ui";
import {
  deleteDeclarationElements,
  getDeclarationElements,
  updateDeclarationElements,
  uploadDeclarationElementExcel,
  getAllDeclarationElements,
  getTableVersionNumberIsMaxDeclarationElements,
} from "@/api/declaration-element";
import Pagination from "@/components/Pagination/index.vue";
import { formatJson } from "@/utils";
import { exportJson2Excel } from "@/utils/excel";
import { cloneDeep } from "lodash";
import { retrieveRawAttr } from "echarts/types/src/data/helper/dataProvider";

@Component({
  name: "declarationElement",
  components: {
    Pagination,
  },
})
export default class extends Vue {
  private tableKey = 0;
  private tableData: TableRowData[] = [];
  private total = 0;
  private listLoading = true;
  private showFileList = false;
  private files: File[] = [];
  private listQuery = {
    pageNumber: 1,
    pageSize: 20,
    customsProductName: null,
    hsCode: null,
  };
  private selectedRow: TableRowData = new TableRowData();
  private dialogFormVisible = false;
  private downloadLoading = false;
  private type = "";

  created() {
    this.getList();
  }

  private async getList() {
    this.listLoading = true;
    const params = Object.assign({}, this.listQuery);
    const { total, content }: any = await getDeclarationElements(params);
    this.total = total;
    this.tableData = (content || []).map((item: any) => ({
      ...item,
      popoverVisible: false,
    }));
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  private handleFilter() {
    this.listQuery.pageNumber = 1;
    this.getList();
  }

  private async handleDelete(row: any) {
    row.popoverVisible = false;
    await deleteDeclarationElements(row.id);
    this.$notify({
      title: "Success",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }

  private showDialog(row: TableRowData) {
    this.selectedRow = cloneDeep(row);
    this.dialogFormVisible = true;
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate();
    });
  }

  private addFile(file: File) {
    if (file.size / 1024 / 1024 >= 100) {
      Message({
        message: "上传的文件大小不能超过100M!",
        type: "error",
        duration: 2 * 1000,
      });
      return;
    }
    this.files.push(file);
  }

  private async handleUpload() {
    let formData = new window.FormData();
    formData.append("file", this.files.pop());
    formData.append("type", this.type);
    await uploadDeclarationElementExcel(formData);
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }

  private handleDownload() {
    this.downloadLoading = true;
    getTableVersionNumberIsMaxDeclarationElements().then(
      (data: any) => {
        this.writeExcel(data);
      },
      (error: any) => {
        this.downloadLoading = false;
        Message({
          message: error.response.data.message || error.response.data,
          type: "error",
          duration: 2 * 1000,
        });
        return Promise.reject(error);
      }
    );
  }

  private writeExcel(list: any) {
    const headers = [
      "报关品名编号",
      "报关品名",
      "英文品名",
      "第一计量单位",
      "英文单位",
      "第二计量单位",
      "英文单位",
      "HS编码",
      "申报要素",
    ];
    const fieldNames = [
      "customsNameCode",
      "customsProductName",
      "englishProductName",
      "firstUnit",
      "firstEnglishUnit",
      "secondUnit",
      "secondEnglishUnit",
      "hsCode",
      "remark",
    ];
    const data = formatJson(fieldNames, list);
    exportJson2Excel(headers, data, "申报要素");
    this.downloadLoading = false;
  }

  private async onDialogConfirmed() {
    await updateDeclarationElements(this.selectedRow.id, this.selectedRow);
    this.dialogFormVisible = false;
    await this.getList();
  }
  private async clickSubmit(type: string) {
    this.type = type;
    this.$refs["upload"]["$refs"]["upload-inner"].handleClick();
  }
}

class TableRowData {
  id: string;
  customsProductName: string;
  englishProductName: string;
  firstUnit: string;
  secondUnit: string;
  hsCode: string;
  remark: string;
  firstEnglishUnit: string;
  secondEnglishUnit: string;
  customsNameCode: string;
  popoverVisible: boolean;
}
